module.exports = __webpack_public_path__ + "static/blog-3-6ffe83bac683c0652a039ec5120e5570.jpeg";